import Vue from 'vue'
import LotteryListOption from './index.vue'

const LotteryList = Vue.extend(LotteryListOption)

export function templateLotteryListVue({ module }) {
  const lotteryList = new LotteryList({
    propsData: {
      module
    }
  }).$mount()
  return lotteryList.$el
}
